import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

const ClientNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-dark">
      <FaExclamationTriangle size={80} className="text-danger mb-4" />
      <h1 className="mb-3 fw-bold clrgreen" >Client Not Found</h1>
      <p className="clrgreen mb-4 text-center px-3" style={{ maxWidth: 500 }}>
        The client you're looking for doesn't exist or the link is incorrect.
        Please verify the URL or contact support for further assistance.
      </p>
     
    </div>
  );
};

export default ClientNotFound;
